import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=51fc6d15&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=51fc6d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc6d15",
  null
  
)

export default component.exports